import { render, staticRenderFns } from "./TotalstandNoHo.vue?vue&type=template&id=8765f79a&scoped=true&"
import script from "./TotalstandNoHo.vue?vue&type=script&lang=js&"
export * from "./TotalstandNoHo.vue?vue&type=script&lang=js&"
import style0 from "./TotalstandNoHo.vue?vue&type=style&index=0&id=8765f79a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8765f79a",
  null
  
)

export default component.exports